(function () {
  
  function initCompare(scope = document) {
    scope.querySelectorAll('.compare-wrapper').forEach(wrapper => {

      if (wrapper.dataset.initialized === 'true') return;
      wrapper.dataset.initialized = 'true';

      const range = wrapper.querySelector('.compare-range');

      let pos = parseFloat(range?.value || 50);
      let dir = 1;
      let raf = null;
      let isDragging = false;
      let autoplay = wrapper.dataset.autoplay === 'true';

      function update(value) {
        value = Math.min(100, Math.max(0, value));
        pos = value;
        wrapper.style.setProperty('--pos', pos + '%');
        if (range) range.value = pos;
      }

      /* ---------- AUTO ANIMATE ---------- */
      function animate() {
        if (isDragging) return;

        pos += dir * 0.15;
        if (pos >= 90) dir = -1;
        if (pos <= 10) dir = 1;

        update(pos);
        raf = requestAnimationFrame(animate);
      }

      function startAuto() {
        if (!autoplay || raf) return;
        raf = requestAnimationFrame(animate);
      }

      function stopAuto() {
        if (raf) cancelAnimationFrame(raf);
        raf = null;
      }

      /* ---------- DRAG SUPPORT ---------- */
      function onPointerMove(e) {
        if (!isDragging) return;

        const rect = wrapper.getBoundingClientRect();
        const isVertical = wrapper.classList.contains('vertical');

        let value;
        if (isVertical) {
          value = ((e.clientY - rect.top) / rect.height) * 100;
        } else {
          value = ((e.clientX - rect.left) / rect.width) * 100;
        }

        update(value);
      }

      wrapper.addEventListener('pointerdown', e => {
        if (e.target.closest('.compare-label')) return;

        e.preventDefault();
        isDragging = true;
        autoplay = false;
        stopAuto();
        wrapper.setPointerCapture(e.pointerId);
        onPointerMove(e);
      });

      window.addEventListener('pointermove', onPointerMove);

      window.addEventListener('pointerup', e => {
        if (!isDragging) return;
        isDragging = false;

        try {
          wrapper.releasePointerCapture(e.pointerId);
        } catch (err) {}
      });

      startAuto();
    });
  }



  /* ---------- INITIAL LOAD ---------- */
  document.addEventListener('DOMContentLoaded', () => {
    initCompare();
  });

  /* ---------- SHOPIFY SECTION LOAD (VERY IMPORTANT) ---------- */
  document.addEventListener('shopify:section:load', (e) => {
    initCompare(e.target);
  });

  /* ---------- OPTIONAL: CUSTOM AJAX HOOK ---------- */
  document.addEventListener('ajax:complete', (e) => {
    initCompare(e.target || document);
  });

  /* ---------- OPTIONAL: MutationObserver (fallback for any dynamic DOM) ---------- */
  const observer = new MutationObserver((mutations) => {
    mutations.forEach(m => {
      m.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          initCompare(node);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();